<!-- <nav class="mobile-nav" #sideNav>
<i
  class="fa fa-times fa-2x"
  (click)="toggleSideNav()"
  aria-hidden="true"
  id="toggle"
></i>

<ul class="mobile-nav-list" #content>
  <p class="mobile-nav-list-logo">SEECH</p>

  <ng-container *ngFor="let item of navItems">
    <li class="mobile-nav-list-item" @if="showMenu(item)" [id]="item.label">
      <a
        [routerLink]="'/' + item.link"
        routerLinkActive="active"
        class="mobile-nav-list-item-link"
        [id]="item.label + 'link'"
        (click)="toggleSideNav()"
        >
        <div class="content-wrapper">
          <img
            [src]="'assets/icons/' + item.link + '-white.svg'"
            [id]="item.label + 'icon'"
            [alt]="item.link + ' icon'"
            />
          <span> {{ item.label | titlecase }} </span>
        </div>
      </a>
    </li>
  </ng-container>
</ul>
</nav> -->

<nav class="mobile-nav bg-white text-" #sideNav>
  <!-- Toggle Button (back arrow) -->
  <div
    class="mobile-nav__head flex items-center justify-between p-0 border-b border-b-grey-light mb-2"
  >
    <div class="logo-wrapper">
      <a [routerLink]="logoLink" role="button" class="logo-link">
        <img [src]="logoUrl" alt="logo" class="logo-link-img" />
      </a>
    </div>
    <i
      [sch-icon]="toggleIcon"
      class="text-primary border border-primary rounded-full h-7 w-7 text-lg flex items-center justify-center cursor-pointer"
      (click)="toggleSideNav()"
    ></i>
  </div>

  <div class="mobile-nav__body">
    <div class="mobile-nav__list">
      <ul>
        @for (
          navItemGroup of navItems;
          track navItemGroup;
          let isFirst = $first
        ) {
          <!-- Conditionally add a border to all arrays except the first -->
          @if (!isFirst && navItemGroup.length > 0) {
            <div class="border-t border-t-grey-light mt-2 pb-2"></div>
          }
          <!-- Loop through individual items within each group -->
          @for (item of navItemGroup; track item) {
            <li class="sidebar-item !text-grey-dark">
              <a
                [routerLink]="'/' + item.link"
                (click)="onItemClick(item)"
                routerLinkActive="active"
                [id]="item.label + 'link'"
                class="flex items-center h-[47px] px-3 list-link"
                (click)="toggleSideNav()"
              >
                <i
                  [sch-icon]="item.icon"
                  class="icon !text-2xl !font-semibold"
                ></i>
                <span class="ms-2">{{ item.label | titlecase }}</span>
              </a>
            </li>
          }
        }
      </ul>
    </div>
    <div class="mobile-nav__footer">
      <ng-content select="[scope]"></ng-content>
      @if (showHub) {
        <button
          type="button"
          class="mobile-nav__hub"
          aria-label="Open SEECH hub"
          (click)="closeSideNav(); hubLaunch.emit()"
        >
          <i sch-icon="dashboard-circle" aria-hidden="true"></i>
          <span>Hub</span>
        </button>
      }
    </div>
  </div>
</nav>
